import { ArticleWarningSummary } from '../ArticleWarningSummary';
import { useWarningNavigation } from '../useWarningNavigation';
import { Box, Flex, Grid } from '@chakra-ui/react';
import { ErrorDetails } from '@texas/components/shared/alert/ErrorDetails';
import { BodyOverride } from '@texas/components/shared/BodyOverride';
import { EntityDirectoryPage } from '@texas/components/shared/entityDirectory/EntityDirectoryPage';
import { articleJobWorkspaceStyles } from '@texas/resources/theme/styles/entityWorkspace';
import { useTranslation } from 'react-i18next';
import { CopyArticleDestination } from './CopyArticleDestination';
import { CopyArticleScope } from './CopyArticleScope';
import { CopyArticleSource } from './CopyArticleSource';
import { CopyArticleSummary } from './CopyArticleSummary';
import {
  CopyArticleProvider,
  CopyArticleProviderProps,
  useCopyArticle,
} from './useCopyArticle';

export function CopyArticlePage(props: CopyArticleProviderProps) {
  return (
    <CopyArticleProvider {...props}>
      <CopyArticleContent />
    </CopyArticleProvider>
  );
}

function CopyArticleContent() {
  const { t } = useTranslation();
  const { error, source, warningItems } = useCopyArticle();
  const navigateToWarning = useWarningNavigation();

  return (
    <BodyOverride>
      <EntityDirectoryPage
        sx={articleJobWorkspaceStyles.page}
        description={t('article.copy.description')}
        gap={6}
        title={t('article.copy.title')}
      >
        {error && <ErrorDetails error={error} />}
        <Grid sx={articleJobWorkspaceStyles.columns}>
          <Box sx={articleJobWorkspaceStyles.sections}>
            <CopyArticleSource />
            {source && (
              <>
                <CopyArticleScope />
                <CopyArticleDestination />
              </>
            )}
          </Box>
          <Flex
            as="aside"
            aria-label={t('article.create.summary')}
            direction="column"
            position={{ lg: 'sticky' }}
            top={4}
            maxH={{ lg: 'calc(100dvh - 144px)' }}
            minW={0}
            minH={0}
          >
            <ArticleWarningSummary
              warnings={warningItems}
              onNavigate={navigateToWarning}
            />
            <CopyArticleSummary />
          </Flex>
        </Grid>
      </EntityDirectoryPage>
    </BodyOverride>
  );
}
